module.exports = __webpack_public_path__ + "static/media/mindef.f82a20bb.png";